import type { ReactNode } from "react";
import { useIntl } from "react-intl";

import CollapsibleListItem from "common/core/collapsible_list/item";
import Grid from "common/details/grid";
import { userFullName } from "util/user";
import { NO_NAME_MESSAGE } from "common/signer/utils";

import Styles from "./index.module.scss";

type Props = {
  user?: {
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    email?: string | null;
  };
  order?: number | null;
  recipientGroupEmail?: string | null;
  canShowEmail?: boolean;
  subheader: ReactNode;
  children: ReactNode;
  expandInitially?: boolean;
};

export function SignerDetailsWrapper({
  user,
  order,
  recipientGroupEmail,
  canShowEmail,
  subheader,
  children,
  expandInitially = true,
}: Props) {
  const intl = useIntl();

  const fullName = userFullName(user);
  let header = order ? `${order} - ` : "";
  if (fullName && recipientGroupEmail) {
    header += `${fullName} (${recipientGroupEmail})`;
  } else {
    const userEmail = canShowEmail ? user?.email : undefined;
    header += recipientGroupEmail || fullName || userEmail || intl.formatMessage(NO_NAME_MESSAGE);
  }

  return (
    <CollapsibleListItem header={header} subheader={subheader} initialDisplay={expandInitially}>
      <Grid className={Styles.noPaddingGrid}>{children}</Grid>
    </CollapsibleListItem>
  );
}
